export type IkasCustomerAttributeSalesChannel = {
  permission: IkasCustomerAttributePermission;
  registerPageRequirement: IkasCustomerAttributeRegisterPageRequirement;
  salesChannelId: string;
  storefrontId: string;
};

export enum IkasCustomerAttributePermission {
  INVISIBLE = "INVISIBLE",
  READ = "READ",
  WRITE = "WRITE",
}

export enum IkasCustomerAttributeRegisterPageRequirement {
  INVISIBLE = "INVISIBLE",
  MANDATORY = "MANDATORY",
  OPTIONAL = "OPTIONAL",
}
